import { isSsoEnabled } from '../auth/cognitoConfig';

let activeOperatorIdentity: string | null = null;

/**
 * Publish the authenticated Cognito subject before rendering operator pages.
 * The value is intentionally kept in memory: persisted data is namespaced by
 * the subject, but the active subject must always come from the verified OIDC
 * session rather than browser storage.
 */
export function setActiveOperatorIdentity(identity: string | null): void {
  activeOperatorIdentity = identity?.trim() || null;
}

export function getOperatorScopedStorageKey(baseKey: string): string | null {
  if (activeOperatorIdentity) {
    return `${baseKey}:${encodeURIComponent(activeOperatorIdentity)}`;
  }
  // The legacy shared-token mode has no individual operator identity and keeps
  // its established keys. SSO fails closed until a verified `sub` is published.
  return isSsoEnabled() ? null : baseKey;
}
